// slide
import '@splidejs/splide/dist/css/splide.min.css';
// slide
const Splide = require('@splidejs/splide').default;
import AOS from "aos";
import "aos/dist/aos.css";
require("slick-carousel");

$(document).ready(function () {
    if ($("#modal-nueva-etapa").length) {
        $("#modal-nueva-etapa").modal("show");
        $("#modal-nueva-etapa")
            .find(".cierra-modal")
            .on("click", function () {
                $("#modal-nueva-etapa").modal("hide");
            });
    }

    /* $(window).scroll(function () {
        if ($("#bienvenido-nueva-etapa")) {
            let scrollTop = $(this).scrollTop();

            const top = $("#bienvenido-nueva-etapa").offset().top;
            const height = $(window).height();

            console.log(top);

            const mensaje_central = top - height / 2;
            console.log(scrollTop, mensaje_central);
            if (
                scrollTop >= mensaje_central &&
                scrollTop <= mensaje_central + 100
            ) {
                $("#bienvenido-nueva-etapa")
                    .not(".visible")
                    .addClass("visible");
                setTimeout(() => {
                    $("#bienvenido-nueva-etapa").removeClass("visible");
                }, 3000);
            }
        }
    }); */
});

if ($(".proyecto-depto #slide-atributos").length) {
    const slide_atributos = new Splide("#slide-atributos", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
        breakpoints: {
            992: {
                perPage: 4,
            },
            768: {
                perPage: 3,
            },
        },
    }).mount();

    slide_atributos.on("active", function (e) {
        const titulo = $(e.slide).find(".slide-in").data("titulo");
        const texto = $(e.slide).find(".slide-in").data("texto");
        const imagen = $(e.slide).find(".slide-in").data("imagen");
        $("#atributos").find("h3").html(titulo);
        $("#atributos").find("p").html(texto);
        $("#atributos")
            .find(".fondo")
            .css("background-image", `url(${imagen})`);
    });
}

if ($(".proyecto-depto #items-galeria-slide").length) {
    new Splide("#items-galeria-slide", {
        type: "loop",
        perPage: 1,
        perMove: 1,
        autoplay: true,
        arrows: false,
        pagination: true,
    }).mount();
}

if ($("#slide-materiales").length) {
    new Splide("#slide-materiales", {
        type: "loop",
        perPage: 1,
        perMove: 1,
        autoplay: true,
        arrows: false,
        pagination: true,
    }).mount();
}
if ($("#items-galeria-slide-nueva-etapa").length) {
    new Splide("#items-galeria-slide-nueva-etapa", {
        type: "loop",
        perPage: 1,
        perMove: 1,
        autoplay: true,
        arrows: false,
        pagination: true,
    }).mount();
}

// modelos
$(".lista-modelos")
    .find(".titulo")
    .on("click", function () {
        if (!$(this).hasClass("is-open")) {
            const mi_lista = $(this).parents("li").find(".lista-plantas");

            $(this)
                .parents(".lista-modelos")
                .find(".lista-plantas.open")
                .slideUp(function () {
                    $(this).removeClass("open");
                });

            mi_lista.slideDown(function () {
                $(this).addClass("open");
                const $this = $($(this).find("li")[0]).find(".link");
                const target = $this.attr("href");
                const $target = $(target);
                seleccionaPlanta($this, $target);
            });
            $(this)
                .parents(".lista-modelos")
                .find(".titulo")
                .removeClass("is-open");
            $(this).addClass("is-open");
        }
    });

const seleccionaPlanta = ($this, $target) => {
    if (!$this.hasClass("selected")) {
        $this.parents(".lista-modelos").find(".link").removeClass("selected");
        $this.addClass("selected");

        $this
            .parents(".los-modelos")
            .find(".imagenes-plantas")
            .find(".planta")
            .fadeOut(function () {
                $(this).removeClass("selected");
            });
        $target.fadeIn(function () {
            $(this).addClass("selected");
        });
    }
};

$(".lista-modelos")
    .find(".link")
    .on("click", function () {
        const $target = $($(this).attr("href"));
        seleccionaPlanta($(this), $target);
    });

$("#info-plantas .slide").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $('.modelo-prev-arrow'),
    nextArrow: $('.modelo-next-arrow'),
})

$('#seleccionar-planta').on('change', function () {
    $("#info-plantas .slide").slick("slickUnfilter");

    filterSlide()

})

filterSlide()

function filterSlide() {
    let val = $('#seleccionar-planta').val();
    $("#info-plantas .slide").slick("slickFilter", function () {
        return $(this).find('.planta').attr("data-id") == val;
    });
}
AOS.init();

require("./modal_promocion");
require("./components/banner_promocion_04_24");

